<template>
  <div class="container mx-auto pb-10">
 

    <!-- 데이터 입력 폼 -->
    <div class="flex flex-wrap justify-between gap-6 max-w-[1400px] mx-auto mt-[13px]">
      <!-- 실시간 크롤링 리스트 테이블 -->
      <div class="flex-1 min-w-[600px]">
      <!-- 헤더 -->
      <div class="flex bg-slate-800 text-white text-xs leading-7 font-semibold py-2 px-6 rounded-t-md items-center justify-between">
        <div class="text-base">실시간 크롤링 리스트</div>

        <!-- ❓ 툴팁 아이콘 -->
        <div class="relative group">
          <div
            class="w-[20px] h-[20px] rounded-full bg-white text-slate-800 flex items-center justify-center text-[12px] font-bold cursor-help"
          >
            ❓
          </div>
          <!-- 툴팁 설명 -->
          <div
            class="absolute hidden group-hover:block text-white bg-gray-700 text-[11px] px-2 py-1 rounded shadow-md top-[120%] right-0 z-10 whitespace-nowrap"
          >
            알림 설정 시 연결할 수 있는 실시간 크롤링 작업 목록입니다.
          </div>
        </div>
      </div>

      <!-- 데이터 Rows (스크롤 적용) -->
      <div class="overflow-y-auto max-h-[160px]">
        <div
          v-for="(row, index) in rowsCrawling"
          :key="index"
          class="flex items-center px-6 py-2 text-[11px] leading-6 cursor-pointer"
          :class="index % 2 === 0 ? 'bg-[#f5f5f5]' : 'bg-[#ECECEC]'"
          @click="handleCrawlingRowClick(row)"
        >
          <div class="w-[5%] flex items-center justify-center">
            <!-- 체크박스 상태를 selected와 바인딩, enable_yn이 '0'이면 비활성화 -->
            <input
              type="checkbox"
              v-model="row.selected"
              :disabled="row.enable_yn === '0'"
              @click.stop
            />
          </div>
          <div class="w-[95%] text-left" :title="row.job_name">
            {{ row.job_name }}
          </div>
        </div>
      </div>

      <!-- No Data -->
      <div v-if="!rowsCrawling.length" class="text-center text-gray-500 text-[11px] py-3 bg-[#f5f5f5]">
        데이터가 없습니다.
      </div>
    </div>


      <!-- 프로젝트 참여 테이블 -->
      <div class="flex-1 min-w-[600px]">
        <!-- <h2 class="font-semibold mb-2 text-left bg-gray-300 px-3 py-2 rounded">프로젝트 참여 현황</h2> -->

        <!-- 헤더 -->
        <div class="flex bg-slate-800 text-white text-xs leading-7 font-semibold py-2 px-6 rounded-t-md">
           
          <div class="w-[80%] text-left text-base">프로젝트 참여인원</div>
        </div>
 
        <!-- 데이터 Rows (스크롤 적용) -->
      <div class="overflow-y-auto max-h-[160px]">
        <div
          v-for="(row, index) in rowsProject"
          :key="index"
          class="flex items-center px-6 py-2 text-[11px] leading-6 cursor-pointer"
          :class="index % 2 === 0 ? 'bg-[#f5f5f5]' : 'bg-[#ECECEC]'"
          @click="handleProjectRowClick(row)"
        >
          <div class="w-[5%] flex items-center justify-center">
            <!-- 체크박스 상태를 selected와 바인딩 -->
            <input
              type="checkbox"
              v-model="row.selected"
              @click.stop
            />
          </div>
          <div class="w-[95%] text-left">
            {{ row.receiver }}
          </div>
        </div>
      </div>


        <!-- No Data -->
        <div v-if="!rowsProject.length" class="text-center text-gray-500 text-[11px] py-3 bg-[#f5f5f5]">
          데이터가 없습니다.
        </div>
      </div> 


      <div class="flex-1 min-w-[600px]"> 
        <h2 class="font-semibold mb-2 text-left text-white bg-slate-700 px-3 py-2 rounded">키워드 등록</h2>

        <div class="mb-2 flex items-center gap-3">
          <input 
            type="text" 
            placeholder="알림 키워드 등록 (최대 10개 등록 가능합니다)" 
            v-model="crawlingKeywordText"
            @keyup.enter="addCrawlingKeyword('AND')"   
            class="flex-1 h-[27px] px-3 rounded-[7px] bg-[#EDEDED] text-[10px] border-none focus:outline-none placeholder:text-[#A5A5A5]"
          >
          <div class="flex gap-1">
            <button 
              class="w-[80px] h-[25px] font-semibold text-[12px] bg-[#01BAEF] text-white rounded-[5px] hover:opacity-90"
              @click="addCrawlingKeyword('AND')"
            >등록</button>
          </div>
        </div>

        <!-- 동적으로 추가된 키워드 태그들 (삭제 가능) -->
        <div class="flex flex-wrap gap-2 ml-[3px] mb-2">
          <div 
            v-for="(keyword, index) in crawlingKeywords" 
            :key="index" 
            :class="[keyword.type === 'AND' ? 'bg-[#01BAEF]' : 'bg-[#EF426F]', 'text-white rounded-[7px] flex items-center px-2 py-1 text-[10px] font-semibold']"
          >
            <span>{{ keyword.text }}</span>
            <button class="ml-1" @click="removeCrawlingKeyword(index)">x</button>
          </div>
        </div>
      </div>
      
      
      <div class="flex-1 min-w-[600px]"> 
        <h2 class="font-semibold mb-2 text-left text-white bg-slate-700 px-3 py-2 rounded">알림 기간 설정</h2>
        <div class="flex items-center mb-2 relative">
          <span class="text-xs mr-2">알림 기간 </span>
          <input 
            type="date" 
            class="p-1 border rounded-[7px] text-xs relative z-10"
            v-model="startDate"
          > 
          <span class="mx-2">~</span>
          <input 
            type="date" 
            class="p-1 border rounded-[7px] text-xs relative z-10"
            v-model="endDate"
          > 
        </div>
      </div>
      
      <!-- 채널 선택 -->
      <div class="flex-1 min-w-[600px]">
        <h2 class="font-semibold mb-2 text-left text-white bg-slate-700 px-3 py-2 rounded">채널 선택</h2> 
        <div class="flex flex-col gap-2">
          <label
            v-for="(channel, index) in selectedChannels"
            :key="index"
            class="flex items-center text-xs"
          >
            <input
              type="checkbox"
              v-model="channel.selected"   
              :value="channel.channel"
              class="mr-2"
            />
            {{ channel.channel }}
          </label>
        </div>
      </div>

      <!-- 이상치 탐지 유형 -->
      <div class="flex-1 min-w-[600px]">
        <h2 class="font-semibold mb-2 text-left text-white bg-slate-700 px-3 py-2 rounded">이상치 탐지 유형</h2>
        <div class="flex flex-col gap-2">
          <label
            v-for="(type, index) in selectedAnomalies"
            :key="index"
            class="flex items-center text-xs"
          >
            <input
              type="checkbox"
              v-model="type.selected"  
              :value="type.type"
              class="mr-2"
            />
            {{ type.type }}
          </label>
        </div>
      </div>

      <!-- 버튼 -->
      <div class="flex-1 min-w-[600px]">
     
        <button 
          type="submit" 
          class="px-6 py-2 ml-3 bg-gray-300 text-black text-sm font-medium rounded hover:bg-slate-700 hover:text-white"
          @click="handListBtn" 
        >
          목록
        </button>
        <button 
          type="submit" 
          class="px-6 py-2 ml-3 bg-gray-300 text-black text-sm font-medium rounded hover:bg-slate-700 hover:text-white"
          @click="handleSaveClick" 
        >
          저장
        </button>
      </div>

    </div>

     
  </div>
</template>

<script setup>
import { onMounted, ref, computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter , useRoute } from 'vue-router'
 
const selectedProject = computed(() => store.state.notification.selectedProject)
const router = useRouter()
const route = useRoute() 
const store = useStore()
const selectedRow = ref(null)
// 테이블 컬럼 정의
const columns = [
  { label: '요청시간',   value: 'requested_date',         width: '10%' },
  { label: '등록키워드', value: 'keywords',         width: '30%' },
  { label: '기간',       value: 'period', width: '25%' },
  { label: '채널',       value: 'channel_names',       width: '10%' },
  { label: '이상치 유형', value: 'anomaly_type_names',      width: '10%' },
  { label: '수신인',     value: 'receiver_names',      width: '15%' },
]

const rows = ref([])          // 테이블 행 데이터
const page = ref(1)           // 현재 페이지
const crawlingKeywords = ref([]);
const crawlingKeywordText = ref('');

// 페이지네이션 계산
const pagination = computed({
  get() {
    return {
      page: page.value,
      perPage: 5,
      lastPage: Math.ceil(rows.value.length / 5),
    }
  },
  set(val) {
    return val
  },
})

async function handleSearch(project_id) {
  

  await store.dispatch('notification/fetchNotificationRegisterList', { 
    project_id, 
    participants : selectedProject.value.participant_ids
  }); 
  
  // 이상치 탐지유형을 가져와서 selectedAnomalies에 바인딩
  const resAnomalyType = store.getters['notification/allAnomalyTypeList'];
  selectedAnomalies.value = resAnomalyType.map(item => ({
    type: item.code_name, // 또는 item.code_name
    selected: item.select_yn === '1', // select_yn이 '1'이면 체크
    code_cd: item.code_pid
  }));

  // 채널 선택 옵션을 가져와서 selectedChannels에 바인딩
  const resChannel = store.getters['notification/allChannelList'];
  selectedChannels.value = resChannel.map(item => ({
    channel: item.code_name, // 채널명
    selected: item.select_yn === '1', // select_yn이 '1'이면 체크
    code_cd: item.code_pid
  }));

  // 프로젝트 참여인원 → 참여자 리스트에 바인딩
  const resReceiver = store.getters['notification/allReceiverList'];
  rowsProject.value = resReceiver.map(item => ({
    receiver: (item.dept_dv_code_nm || '') + '_' + (item.mber_nm || '') + '_' + (item.email || ''),  // 이름 필드
    selected: '0',  // user_yn이 '1'일 때 체크박스 체크
    user_id : item.mber_pid,
    user_email : item.email,
    user_nm : item.mber_nm

  }));

  // 실시간 크롤링 리스트 → 리스트 바인딩
  const resCrawlingList = store.getters['notification/allCrawlingList'];
  rowsCrawling.value = resCrawlingList.map(item => ({
    job_name: item.job_name || '',
    selected: item.select_yn === '1',
    job_id: item.id,
    enable_yn: item.enable_yn // 🔹 추가
  }));

}


onMounted(() => { 
  const project_id = route.query.project_id;  
  handleSearch(project_id)
})

// 실시간 크롤링 테이블 컬럼
const columnsCrawling = [
  { label: '', type: 'checkbox', width: '5%' }, // 체크박스 컬럼
  { label: '실시간 크롤링', value: 'job_name', width: '95%' } // crawl_title 컬럼
]

// 실시간 크롤링 데이터는 실제 데이터를 받아서 설정
const rowsCrawling = ref([]); // 실제 데이터로 채울 예정

// 프로젝트 참여 테이블 컬럼
const columnsProject = [
  { label: '', type: 'checkbox', width: '5%' }, // 체크박스 컬럼
  { label: '이름', value: 'user_nm', width: '95%' } // member_name 컬럼
]

// 프로젝트 참여 데이터는 실제 데이터를 받아서 설정
const rowsProject = ref([]); // 실제 데이터로 채울 예정
  

// 선택된 값 바인딩
const selectedChannels = ref([])
const selectedAnomalies = ref([]) 
const startDate = ref('');
const endDate = ref('');

/**
 * 지정한 인덱스의 crawling keyword를 삭제
 * @param {number} index 
 */
function removeCrawlingKeyword(index) {
  crawlingKeywords.value.splice(index, 1);
}

// 키워드 가공용 함수 (쉼표로 구분된 문자열 → 키워드 배열로 변환)
function parseKeywords(keywordsStr) {
  return (keywordsStr || '')
    .split(',')
    .map(k => k.trim())
    .filter(k => k.length > 0)
    .map(text => ({ text, type: 'AND' }));  // 기본은 AND
}
   
// AND 타입 키워드만 실제 키워드로 추가
const andKeywords = crawlingKeywords.value
  .filter(keyword => keyword.type === 'AND')
  .map(keyword => keyword.text);
 
  
/**
 * 입력된 텍스트가 있을 경우 AND/NOT 버튼 클릭 시 keyword 객체를 추가
 * @param {string} type - 'AND' 또는 'NOT'
 */
function addCrawlingKeyword(type) {

  // AND 키워드가 이미 8개 이상이면 추가 금지
  if (type === 'AND') {
    const andCount = crawlingKeywords.value.filter(k => k.type === 'AND').length;
    if (andCount >= 10) {
      store.commit('handleNotify', { message: 'AND 키워드는 최대 8개까지 추가할 수 있습니다.' }); 
      // alert("AND 키워드는 최대 8개까지 추가할 수 있습니다.");
      return;
    }
  }


  if (crawlingKeywordText.value.trim() !== '') {
    crawlingKeywords.value.push({
      text: crawlingKeywordText.value.trim(),
      type: type  // 'AND'면 파란색(#01BAEF), 'NOT'이면 빨간색(#EF426F)
    });
    crawlingKeywordText.value = '';
  }
} 
 
async function handListBtn() {
  const from = route.query.from;

  if (from) {
    router.push(from);  // 👈 정확히 원래 페이지로 이동
  } else {
    router.back(); // fallback
  }
}

async function handleSaveClick() {
  const confirmDelete = window.confirm("해당 알림을 저장하시겠습니까?");
  if (!confirmDelete) {
    return;  // 사용자가 취소함
  }

  const project_id = route.params?.project_id; 
  // 실시간 크롤링 리스트
  const Crawling = rowsCrawling
  // 프로젝트 참여인원
  const Project = rowsProject
  // 이상치 탐지 유형
  const Anomalies = selectedAnomalies
  // 채널 리스트
  const Channels = selectedChannels
  // 등록키워드
  const craKeywords = crawlingKeywords
  // 알람 기간
  const startDt = startDate
  const endDt = endDate  
 

  if (crawlingKeywords.value.length === 0) {
    store.commit('handleNotify', { message: '키워드를 1개 이상 등록해주세요.' });
    return;
  }

  const selectedCrawling = rowsCrawling.value.filter(row => row.selected);
  if (selectedCrawling.length === 0) {
    store.commit('handleNotify', { message: '실시간 크롤링 항목을 1개 이상 선택해주세요.' });
    return;
  }

  const selectedReceivers = rowsProject.value.filter(row => row.selected);
  if (selectedReceivers.length === 0) {
    store.commit('handleNotify', { message: '프로젝트 참여자를 1명 이상 선택해주세요.' });
    return;
  }

  const selectedChannelsFinal = selectedChannels.value.filter(ch => ch.selected);
  if (selectedChannelsFinal.length === 0) {
    store.commit('handleNotify', { message: '채널을 1개 이상 선택해주세요.' });
    return;
  }

  const selectedAnomaly = selectedAnomalies.value.filter(a => a.selected);
  if (selectedAnomaly.length === 0) {
    store.commit('handleNotify', { message: '이상치 탐지 유형을 1개 이상 선택해주세요.' });
    return;
  }

  if (!startDate.value || !endDate.value) {
    store.commit('handleNotify', { message: '알림 기간을 설정해주세요.' });
    return;
  }

  // ✅ 시작일이 종료일보다 뒤일 경우
  if (new Date(startDate.value) > new Date(endDate.value)) {
    store.commit('handleNotify', { message: '시작일은 종료일보다 앞서야 합니다.' });
    return;
  }
  
  const res = await store.dispatch('notification/saveInsertNotificationList', { 
    Crawling,
    Project,
    Anomalies,
    Channels,
    craKeywords,
    startDt,
    endDt, 
  });
 
  if(res){
    store.commit('handleNotify', { message: '저장되었습니다.', type: 'success' });
    const from = route.query.from;

    if (from) {
      router.push(from);  // 👈 정확히 원래 페이지로 이동
    } else {
      router.back(); // fallback
    }
  }
 
}


// 신규 등록 페이지로 이동
function goToRegister() {
  router.push('/pub/qa/register')
}


function handleCrawlingRowClick(row) {
  if (row.enable_yn === '1') {
    row.selected = !row.selected;
  }
}
 

function handleProjectRowClick(row) {
  row.selected = !row.selected;
}

</script>

<style scoped>
/* 시각적으로 숨김 처리 (접근성 고려) */
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>
